import React, { useContext } from "react";
import Can from "../can/Can";
import { AppContext } from "../../App";
import { swap } from "../../rbac-consts";
import SwapContainer from "./master/SwapContainer";

const SwapWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={swap.MASTER}
      yes={() => (
        <SwapContainer />
      )}
    />
  );
};

export default SwapWrapper;